// import {useEffect} from 'react';

// import { Link } from 'react-router-dom';
// import CVIShipmentInsurance from './CVIShipmentInsurance';
// import MotorInsurance from './MotorInsurance';
// import PersonalInsurance from './PersonalInsurance';
// import STIHealthInsurance from './STIHealthInsurance';

// const FinancialServices = () => {
//     useEffect(()=>{
//         let current_page = window.location.href.split('/').at(-1)
//         setTimeout(()=>{
//             document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
//         }, 100)
//     })
//     window.addEventListener("scroll", function(event) {
//         let top = this.scrollY,
//             window_width = window.innerWidth,
//             header_height = document.querySelector("header").style.height+100;
//             // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
//             (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
//     }, false);
//     window.addEventListener("scroll", function(event) {
//         let top = this.scrollY,
//             window_width = window.innerWidth,
//             header_height = document.querySelector("header").style.height+100;
//             (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
//             // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
//     }, false);

//     return(
//         <div>
//             <div id='international' className="financial-services-image">
//                 <img src='/financial-services/main-banner.jpg' alt='' className='w-[100%]'/>
//             </div>
//             <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
//                 <p>
//                     TCS Financial Services aims to be a unique financial services provider in Pakistan by creating
//                     internal and external strategic alliances. We offer extraordinarily customer-oriented products
//                     and creative delivery channels to build strong customer relationships. Our financial solutions
//                     serve by employing latest fintech, human resource models and forty years of market insights.
//                 </p>
//                 <p>
//                 Working as the sales and distribution partner for multiple insurance companies, TCS Financial
//                 Services division also provides its customers with the insurance/takaful solutions suitable
//                 for their needs.
//                 </p>

//                 <div className="MuiFormGroup-root MuiFormGroup-row">
//                     <div className="md:flex grid pb-[50px]">
//                         <div className="flex-1 flex flex-col">
//                             <div className="flex items-center ">
//                                 <li><Link to="/financial-services/stihealthinsurance"  className='font-bold'>Sahulat Telehealth Insurance</Link></li>
//                             </div>
//                             <div className="flex items-center">
//                                 <li><Link to="/financial-services/cvishipment" className='font-bold'>Customer Voluntary Insurance</Link></li>
//                             </div>

//                         </div>

//                         <div className="flex-1 flex flex-col">
//                             <div className="flex items-center">
//                                 <li><Link to="/financial-services/motorinsurance" className='font-bold'>Motor Insurance</Link></li>
//                             </div>
//                             <div className="flex items-center">
//                                 <li><Link to="/financial-services/personalinsurance" className='font-bold'>Personal Insurance</Link></li>
//                             </div>

//                         </div>

//                     </div>
//                 </div>

//             </div>

//             <div className='mx-[2rem] md:mx-[0rem]'>
//             <div id="stihealthinsurance">
//                 <STIHealthInsurance />
//             </div>
//             <div id="cvishipment">
//                 <CVIShipmentInsurance />
//             </div>
//             <div id="motorinsurance">
//                 < MotorInsurance/>
//             </div>
//             <div id="personalinsurance">
//                 <PersonalInsurance />
//             </div>
//             </div>

//         </div>
//     )
// };
// export default FinancialServices;

import {
  Bike,
  Car,
  HeartPulse,
  MapPin,
  Package,
  Shield,
  Smartphone,
  WalletCards,
  Stethoscope,
  ArrowRight,
} from "lucide-react";
import { Link } from "react-router-dom";

const insuranceProducts = [
  {
    title: "Shipment Transit Insurance",
    icon: Package,
    description:
      "Shipment Transit Insurance provides peace of mind by protecting your valuable packages against loss or physical damage while in transit across our network.",
  },
  {
    title: "Personal Accident Insurance / Takaful",
    icon: Shield,
    description:
      "Provides financial protection to the insured against accidental death, accidental bodily injury, and temporary or permanent disability, including compensation for loss of eyes, limbs and speech.",
  },
  {
    title: "Health Insurance / Takaful",
    icon: HeartPulse,
    subProducts: [
      {
        title: "In-Patient Health Insurance",
        description:
          "Covers the policyholder and their family members under a single premium policy with a fixed Annual Limit, providing financial protection in case of hospitalization or diagnosed illness.",
      },
      {
        title: "Hospital Cashback Takaful",
        description:
          "Provides a daily cash benefit for hospitalization with no limit on admissions during the policy term. The benefit doubles for ICU stays, with injury treatment expenses covered up to the annual limit.",
      },
    ],
  },
  {
    title: "Digital Healthcare",
    icon: Stethoscope,
    description:
      "Oladoc & Marham Digital Healthcare Plan offers comprehensive online healthcare services, including unlimited consultations with general practitioners and specialists, discounted lab tests and medications, and discounts on surgeries. This plan provides coverage for individuals and their families, including parents, ensuring convenient and affordable access to quality healthcare.",
  },
  {
    title: "Wallet Takaful",
    icon: WalletCards,
    description:
      "Covers the loss of items in a wallet such as CNIC/Smart NIC, driver's license, and ATM/Debit cards, and provides compensation for the inconvenience caused by the loss.",
  },
  {
    title: "Gadget Takaful",
    icon: Smartphone,
    description:
      "Covers loss due to theft, burglary, violent means, and/or armed hold-up.",
  },
  {
    title: "Motor Bike Insurance",
    icon: Bike,
    description:
      "Coverage for loss or damage to the bike from accidents, fire, theft, natural calamities, riots, or other perils; liability for third-party injury, death, or property damage; and medical expenses for any occupant injured in an accident.",
  },
  {
    title: "Motor Car Insurance / Takaful",
    icon: Car,
    description:
      "Covers loss or damage due to accidents, fire, theft, natural calamities, and riots, while also providing third-party liability and medical expense coverage for occupants.",
  },
];

const FinancialServices = () => {
  return (
    <div className="bg-white">
      {/* Hero Banner */}
      <div
        id="international"
        className="financial-services-image overflow-hidden"
      >
        <img
          src="/financial-services/main-banner.jpg"
          alt="TCS Financial Services"
          className="w-full h-auto object-cover"
        />
      </div>

      {/* Main Content */}
      <main className="mx-[2rem] md:mx-auto max-w-[1000px] px-0 md:px-[2rem] lg:px-0 py-8 md:py-12 lg:py-16">
        {/* Introduction */}
        <section className="mb-12 md:mb-16">
          <p className="text-base md:text-[17px] leading-7 md:leading-8 text-gray-600 max-w-[900px]">
            TCS Financial Services aims to empower individuals and businesses
            across Pakistan by offering accessible, customer-centric insurance
            and Takaful solutions. Leveraging our nationwide network and
            alliances with reputable service providers, we deliver innovative
            and affordable financial protection tailored to your evolving needs.
          </p>
        </section>
        {/* Trusted Partners */}
        <section className="mb-12 md:mb-16">
          {/* Heading */}
          <div className="mb-6 flex justify-center px-4 sm:mb-8">
            <div className="border-l-4 border-[oklch(0.56_0.229_27.6)] pl-4 md:pl-5">
              <h2 className="text-2xl font-bold leading-tight text-gray-900 sm:text-3xl">
                Our Trusted Partners
              </h2>
            </div>
          </div>

          {/* Responsive Image */}
          <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
            <div className="overflow-hidden rounded-2xl">
              <img
                src="/financial-services/financialnew.jpg"
                alt="Our Trusted Partners"
                className="block h-auto w-full object-cover"
              />
            </div>
          </div>
        </section>
        {/* Insurance & Takaful */}
        <section>
          <div className="mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight mb-4">
              Our Insurance &amp; Takaful Offerings
            </h2>

            <p className="text-base md:text-[17px] leading-7 md:leading-8 text-gray-600 max-w-[900px]">
              TCS Financial Services offers a diverse range of insurance and
              Takaful solutions, tailored to meet the individual needs and
              preferences of our customers.
            </p>
          </div>

          {/* Products */}
          <div className="space-y-5">
            {insuranceProducts.map((product) => {
              const Icon = product.icon;

              return (
                <article
                  key={product.title}
                  className="group border border-gray-200 rounded-xl p-5 md:p-6 transition-all duration-200 hover:border-gray-300 hover:shadow-sm"
                >
                  <div className="flex gap-4 md:gap-5">
                    {/* Icon */}
                    <div className="shrink-0">
                      <div className="flex items-center justify-center w-11 h-11 md:w-12 md:h-12 rounded-lg bg-[oklch(0.56_0.229_27.6)]/10 text-[oklch(0.56_0.229_27.6)] transition-colors duration-200 group-hover:bg-[oklch(0.56_0.229_27.6)] group-hover:text-white">
                        <Icon size={25} strokeWidth={1.9} />
                      </div>
                    </div>

                    {/* Content */}
                    <div className="min-w-0 flex-1">
                      <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2">
                        {product.title}
                      </h3>

                      {product.description && (
                        <p className="text-[15px] md:text-base leading-7 text-gray-600">
                          {product.description}
                        </p>
                      )}

                      {/* Health Sub Products */}
                      {product.subProducts && (
                        <div className="mt-5 space-y-5">
                          {product.subProducts.map((subProduct) => (
                            <div
                              key={subProduct.title}
                              className="border-l-2 border-gray-200 pl-4 md:pl-5"
                            >
                              <h4 className="text-base md:text-lg font-semibold text-gray-900 mb-1.5">
                                {subProduct.title}
                              </h4>

                              <p className="text-[15px] md:text-base leading-7 text-gray-600">
                                {subProduct.description}
                              </p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </section>
        {/* Disclaimer */}
        <section className="mt-10 md:mt-14">
          <div className="rounded-xl border border-gray-200 bg-gray-50 p-5 md:p-6">
            <div className="flex gap-3">
              <div className="mt-1 shrink-0">
                <Shield size={19} className="text-gray-500" />
              </div>

              <div>
                <h3 className="font-bold text-gray-900 mb-2">Disclaimer</h3>

                <p className="text-sm md:text-[10px] leading-6 text-gray-600">
                  TCS Financial Services acts as a corporate agent for insurance
                  and Takaful companies. All underwriting, claim approvals, and
                  claim liability rest entirely with the respective insurance
                  provider.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Express Centre CTA */}
        <section className="mt-8 md:mt-10">
          <div className="group relative overflow-hidden rounded-2xl bg-[oklch(0.56_0.229_27.6)] px-5 py-5 md:px-7 md:py-6 text-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg">
            {/* Subtle background decoration */}
            <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-white/10 transition-transform duration-500 group-hover:scale-125" />

            <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
              {/* Left Content */}
              <div className="flex items-center gap-4">
                {/* Icon */}
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white/15 ring-1 ring-white/20 transition-transform duration-300 group-hover:scale-105">
                  <MapPin size={22} strokeWidth={2} />
                </div>

                {/* Text */}
                <div>
                  <p className="text-lg md:text-xl font-bold">
                    Visit Your Nearest TCS Express Centre
                  </p>
                </div>
              </div>

              {/* CTA Button */}
              <Link
                to="/tcs-nearyou"
                className="group/button flex w-full shrink-0 items-center justify-center gap-2 rounded-lg bg-white px-5 py-3 text-sm font-semibold text-red-600 hover:text-red-600 shadow-sm transition-all duration-200 hover:bg-gray-50 sm:w-auto"
              >
                Find a Centre
                <ArrowRight
                  size={17}
                  className="transition-transform duration-200 group-hover/button:translate-x-1"
                />
              </Link>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default FinancialServices;
